export default "__VITE_ASSET__eaaff9c0__"